﻿window.VoterFly.Social = {
    facebookShare: function (shareUrl, contenderId, userId) {
        window.VoterFly.Instrumentation.logShare(shareUrl, contenderId, userId, "Facebook");
        // Default dimensions
        var w = 600;
        var h = 500;

        // Calculate center of screen for desktop
        var left = (screen.width / 2) - (w / 2);
        var top = (screen.height / 2) - (h / 2);

        const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;

        // Open popup
        var newWindow = window.open(
            url,
            'fbshare',
            'toolbar=0,status=0,resizable=1,width=' + w + ',height=' + h + ',top=' + top + ',left=' + left
        );

        // Fallback for mobile (let it open in full tab if popup fails)
        if (window.focus && newWindow) {
            newWindow.focus();
        }

        return false; // prevent default link navigation
    },

    isNativeShareSupported: function () {
        return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
    },

    nativeShare: function (shareUrl, title, text, contenderId, userId) {

        window.VoterFly.Instrumentation.logShare(shareUrl, contenderId, userId, "Native");

        return navigator.share({
            title: title,
            text: text,
            url: shareUrl
        }).catch(function (error) {
            // AbortError just means the user closed the share sheet without picking anything.
            if (error && error.name !== 'AbortError') {
                console.error('Native share failed', error);
            }
        });
    }
};
